import { Card, Flex, Radio } from "@/atoms"
import { InformationPopover } from "@/molecules/InformationPopover"

import styles from "./CardRadio.module.scss"

import type { CardRadioComponent } from "."

export const CardRadio: CardRadioComponent = (props) => (
  <Card className={styles.card}>
    <Radio value={props.value} data-testid={props.value}>
      <Flex align="center" gap={4}>
        <span data-testid={props.value}>{props.label}</span>
        {props.content && (
          <InformationPopover.Popover
            content={
              <InformationPopover.CommonTemplate>
                {props.content}
              </InformationPopover.CommonTemplate>
            }
          />
        )}
      </Flex>
    </Radio>
    {props.selected && <div className={styles.wrapper}>{props.children}</div>}
  </Card>
)
